import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuItem } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-restore-button',
  templateUrl: './restore-button.component.html',
  styleUrls: ['./restore-button.component.scss'],
  imports: [TranslateModule, MatMenuItem, MatIconButton, MatTooltip, MatIcon],
})
export class RestoreButtonComponent {
  @Input() isMenu = false;

  constructor() {}
}
